import React from "react";
import Empty from "@ui-kit/empty";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";

export interface SharedWidgetsEmptyProps {
  empty: boolean;
  children: React.ReactNode;
  emptyMessage?: string;
}

export default function SharedWidgetsEmpty({
  empty,
  emptyMessage,
  children,
}: SharedWidgetsEmptyProps) {
  const locale = useCurrentUserLocale();
  return (
    <>
      {empty ? (
        <Empty
          message={emptyMessage || tr(locale, "CUSTOM_PAGES.WIDGET.NO_DATA")}
        />
      ) : (
        children
      )}
    </>
  );
}
